var _style, _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRari(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CIRCLE_OUTLINE_BLACK",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:none;}\n\t.st3{fill:url(#SVGID_2_);}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 255.7,
    cy: 259.9,
    r: 220.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 52.6495,
    cy: 388.8244,
    r: 367.8217,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06888,
    style: {
      stopColor: "#1C5DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    style: {
      stopColor: "#2263FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3383,
    style: {
      stopColor: "#3475FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#5292FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    style: {
      stopColor: "#5D9DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#619BFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7103,
    style: {
      stopColor: "#7098FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    style: {
      stopColor: "#8791F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    style: {
      stopColor: "#A889F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9494,
    style: {
      stopColor: "#D27EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F077EB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.3,224.8h-81.1V239h81.1c3.9,0,7.1-3.2,7.1-7.1S299.2,224.8,295.3,224.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.3,224.8h-81.1V239h81.1c3.9,0,7.1-3.2,7.1-7.1S299.2,224.8,295.3,224.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 52.6495,
    cy: 388.8244,
    r: 367.8217,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06888,
    style: {
      stopColor: "#1C5DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    style: {
      stopColor: "#2263FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3383,
    style: {
      stopColor: "#3475FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#5292FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    style: {
      stopColor: "#5D9DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#619BFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7103,
    style: {
      stopColor: "#7098FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    style: {
      stopColor: "#8791F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    style: {
      stopColor: "#A889F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9494,
    style: {
      stopColor: "#D27EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F077EB"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M363.6,288.6v44.9h-61.9 v-38.1c0,0,2.5-16.1-20.3-16.1h-67v54.2h-66.1V178.4h172.9c0,0,42.4,5.1,42.4,36.4s-20.3,40.7-20.3,40.7S363.6,268.3,363.6,288.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRari);
export default __webpack_public_path__ + "static/media/rari.230b087fc0f59c276e64430b14139c31.svg";
export { ForwardRef as ReactComponent };